import videojs from 'video.js';
import Player from 'video.js/dist/types/player';

const PromoVideoPlayer = (() => {
    let currentPlayer: Player | null = null; // To keep track of the currently playing player

    // Function to initialize players
    const initPlayers = () => {
        const videoElementId = 'player-promo';

        // First, check if a player for this ID has already been initialized.
        const existingPlayer = videojs.getPlayer(videoElementId);

        if (existingPlayer) {
            // If the player already exists, we don't need to do anything.
            // This prevents the "already initialised" warning.
            console.log('Player "player-promo" is already initialized. Skipping setup.');
            return;
        }

        const videoElement = document.getElementById(videoElementId) as HTMLVideoElement;

        if (!videoElement) {
            console.error(`Video element with ID "${videoElementId}" not found.`);
            return; // Exit if the video element is not found
        }

        // Now it's safe to initialize the player because we know one doesn't exist.
        const player = videojs(videoElement.id, {
            controls: true, // Show default controls
            autoplay: false,
            preload: 'auto'
        });

        const customPlayButton = document.querySelector<HTMLButtonElement>(`.custom-play-button[data-id="${videoElement.dataset.id}"]`);

        if (!customPlayButton) {
            console.warn(`Custom play button for video "${videoElement.dataset.id}" not found.`);
        }

        // Event listener for custom play button
        customPlayButton?.addEventListener('click', () => {
            player.play(); // Play the selected video
        });

        // Show the custom play button when video ends
        player.on('ended', () => {
            if (customPlayButton) {
                customPlayButton.style.display = 'block'; // Show the custom play button
            }
            if (currentPlayer === player) {
                currentPlayer = null; // Clear the current player reference
            }
        });

        // Handle events when the video starts playing
        player.on('play', () => {
            // If another video is playing, pause it.
            if (currentPlayer && currentPlayer !== player) {
                currentPlayer.pause();
            }

            // Set the current player to this one.
            currentPlayer = player;

            // Hide the custom play button
            if (customPlayButton) {
                customPlayButton.style.display = 'none';
            }
        });
    };

    // Function to stop the currently playing video
    const stopPlaying = () => {
        if (currentPlayer) {
            currentPlayer.pause(); // Pause the currently playing video

            // --- FIX START ---
            // Cast the player's element to HTMLElement to access the dataset property
            const playerElement = currentPlayer.el() as HTMLElement;
            const customPlayButton = document.querySelector<HTMLButtonElement>(`.custom-play-button[data-id="${playerElement.dataset.id}"]`);
            // --- FIX END ---

            if (customPlayButton) {
                customPlayButton.style.display = 'block';
            }
            currentPlayer = null; // Reset current player reference
            console.log('Video stopped.');
        }
    };

    // Expose the initPlayers and stopPlaying functions
    return { initPlayers, stopPlaying };
})();

// Export the instance with both functions
export default PromoVideoPlayer;
